module.exports = __webpack_public_path__ + "img/55.8f183cbf.jpg";